import React from 'react';
import PropTypes from 'prop-types';
import Cldr from 'utils/Cldr';
import styles from './index.scss';
import { cartDataProps } from '../../../shared/prop-types';

const Pricing = ({ isPrimary, label, cartData, showFootnote }) => {
  const amount = isPrimary ? cartData.billedToday : cartData.recurringAmount;

  return (
    <div className={styles.container}>
      <h4 className={`${styles.row} ${isPrimary ? 'text-bold' : ''}`}>
        <p>{label}</p>
        <p data-testid="bill-amount">
          {Cldr.formatCurrency(amount, cartData.currency)}
        </p>
      </h4>
      {showFootnote && <small>Cancel anytime</small> /* TODO: [fumba] copy */}
    </div>
  );
};

Pricing.propTypes = {
  isPrimary: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  cartData: cartDataProps.isRequired,
  showFootnote: PropTypes.bool.isRequired
};

export default Pricing;
